module.exports = __webpack_public_path__ + "static/media/Trash_Can_Icon_White.d5fad814.svg";